import React from "react"
import styled from "styled-components"
import TitlePrimary from "../../shared/components/text/TitlePrimary";
import useTranslation from "../../shared/utils/translation";
import ParagraphBold from "../../shared/components/text/ParagraphBold";
import PersonnelGrid from "../../shared/components/PersonnelGrid";
import {subHeading} from "../../shared/utils/vars";

const WhoAreWeSectionWrapper = styled.section``

const TitleWrapper = styled.div`
  text-align: start;
  margin-bottom: 30px;
`

function WhoAreWeSection() {
  const t = useTranslation()

  return (
    <WhoAreWeSectionWrapper>
      <TitleWrapper>
        <TitlePrimary color={subHeading} small={true}>{t("title.whoarewe")}</TitlePrimary>
      </TitleWrapper>
      <ParagraphBold>{t("who.paragraph")}</ParagraphBold>
      <PersonnelGrid/>
    </WhoAreWeSectionWrapper>
  )
}

export default WhoAreWeSection
